import { WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import AddCircle from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IMessage } from '../actions/message';
import {
	IManageGroup,
	IManageOrg,
	IProfile,
	IUserOrg,
	setEditedProfile,
	setSaveProfileCompleteFlg,
	setStoredProfile,
} from '../actions/profile';
import { IUserAttr } from '../actions/session';
import { ISelectUser } from '../actions/user';
import MessageDialog from '../components/MessageDialog';
import FormSelect from '../components/ProfileFormSelect';
import TextField from '../components/ProfileTextField';
import noImage from '../images/no_image.png';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import NavbarScenarioFactory from '../scenario/NavbarScenarioFactory';
import ScenarioFactory, {
	ISaveUserProfileParam,
} from '../scenario/ProfileScenarioFactory';
import Config from '../site.config.json';
import FormLabel from '../utils/FormLabelWrapper';
import InputCheck from '../utils/InputCheck';
import { isMobile } from '../utils/MobileCheck';
import SelectUser from './SelectUser';

const styles = (theme: Theme) =>
	createStyles({
		cssLabel: {
			'&$cssFocused': {
				color: `${theme.palette.primary.light} !important`,
			},
			color: theme.palette.primary.light,
		},
		cssUnderline: {
			'&:after': {
				borderBottomColor: theme.palette.primary.light,
			},
			'&:before': {
				borderBottomColor: theme.palette.primary.light,
			},
			'&:hover:not($disabled):not($focused):not($error):before': {
				borderBottomColor: `${theme.palette.primary.main} !important`,
			},
		},
		disabled: {
			backgroundColor: 'gray',
		},
		formGroup: {
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
		},
		iconAdd: {
			color: green[500],
		},
		iconEdit: {
			color: orange[500],
		},
		iconRemove: {
			color: red[500],
		},
		iconRemoveDisabled: {
			color: grey[500],
		},
		layout: {
			marginBottom: theme.spacing(3),
			marginLeft: theme.spacing(2),
			marginRight: theme.spacing(2),
			marginTop: theme.spacing(3),
			width: 'auto',
			[theme.breakpoints.up(800 + theme.spacing(2) * 2)]: {
				marginLeft: 'auto',
				marginRight: 'auto',
				width: 800,
			},
		},
		paper: {
			margin: theme.spacing(2),
			padding: theme.spacing(2),
		},
	});

interface IState {
	enableImgDelButton: boolean;
	showPassword: boolean;
	userImg: string;
	openErrorMessageDialog: boolean;
	messages: IMessage[];
	selectUserOpen: boolean;
}

/**
 * ユーザ情報フォーム
 */
class ProfileForm extends React.Component<IProps, IState> {
	protected uploadForm: HTMLFormElement | null;
	protected uploadFile: HTMLInputElement | null;

	public constructor(props: IProps) {
		super(props);

		this.state = {
			enableImgDelButton: false,
			messages: [],
			openErrorMessageDialog: false,
			selectUserOpen: false,
			showPassword: false,
			userImg: noImage,
		};
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		// if (this.props.setStoredProfileAt) {
		//     return;
		// }
		this.props.fetchProfile(this.props.token);
	}

	public render() {
		const { classes } = this.props;
		const edited = this.props.editedProfile;
		const stored = this.props.storedProfile;

		// 完了メッセージダイアログの設定
		const messages: IMessage[] = [];
		if (this.props.needLogoutFlg) {
			messages.push({
				content: 'LMCM_I_00466',
			});
		} else if (this.props.saveCompleteFlg) {
			messages.push({
				content: 'LMCM_I_00007',
			});
		}
		const completeDialogCallback = this.props.needLogoutFlg
			? this.handleMessageDialogCloseWithLogout
			: this.handleMessageDialogClose;

		// 所属組織
		const userOrgs: string[] = [];
		edited.userOrgs.map((userOrg: IUserOrg) => {
			const { additionalFlg, orgName, titleName } = userOrg;
			let titleLabel = '';
			if (additionalFlg) {
				titleLabel = i18n.t('ProfileForm_0001');
			} else {
				titleLabel = i18n.t('ProfileForm_0002');
			}
			let name = '';
			if (InputCheck.isBlank(titleName)) {
				name = orgName + '(' + titleLabel + ')';
			} else {
				name = orgName + '(' + titleLabel + ',' + titleName + ')';
			}
			userOrgs.push(name);
		});

		// 管理対象組織
		const manageOrgs: string[] = [];
		edited.orgs.map((org: IManageOrg) => {
			manageOrgs.push(org.name);
		});

		// 管理対象グループ
		const manageGroups: string[] = [];
		edited.groups.map((group: IManageGroup) => {
			manageGroups.push(group.name);
		});

		let userImage = this.state.userImg;
		let enableImgDelButton = this.state.enableImgDelButton;
		if (stored.existsImageFile && !edited.deleteImage) {
			userImage =
				Config.tsqPath +
				'/tsq/pkg/action/userImage.action?userId=' +
				this.props.userAttr.userId;
			enableImgDelButton = true;
		}

		// 表示制御
		const enablePasswordEdit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_PASSWORD_EDIT'
			) === -1;
		const enableUserNameEdit =
			this.props.userAttr.authorityList.indexOf('PER_USER_NAME_EDIT') ===
			-1;
		const enableUserPhotoEdit =
			this.props.userAttr.authorityList.indexOf('PER_USER_PHOTO_EDIT') ===
			-1;
		const enableUserCountryEdit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_COUNTRY_EDIT'
			) === -1;
		const enableUserTimezoneEdit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_TIMEZONE_EDIT'
			) === -1;
		const enableUserLangEdit =
			this.props.userAttr.authorityList.indexOf('PER_USER_LANG_EDIT') ===
			-1;
		const enableUserLeaderEdit =
			this.props.userAttr.authorityList.indexOf('PER_USER_LEDER_EDIT') ===
			-1;
		const enableUserAddressEdit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_ADDRESS_EDIT'
			) === -1;
		const enableUserTelEdit =
			this.props.userAttr.authorityList.indexOf('PER_USER_TEL_EDIT') ===
			-1;
		const enableUserFaxEdit =
			this.props.userAttr.authorityList.indexOf('PER_USER_FAX_EDIT') ===
			-1;
		const enableUserEmail1Edit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_EMAIL1_EDIT'
			) === -1;
		const enableUserEmail2Edit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_EMAIL2_EDIT'
			) === -1;
		const enableUserCareerMemoEdit =
			this.props.userAttr.authorityList.indexOf(
				'PER_USER_CAREERMEMO_EDIT'
			) === -1;
		const allDisabled =
			!enablePasswordEdit &&
			!enableUserNameEdit &&
			!enableUserPhotoEdit &&
			!enableUserCountryEdit &&
			!enableUserTimezoneEdit &&
			!enableUserLangEdit &&
			!enableUserLeaderEdit &&
			!enableUserAddressEdit &&
			!enableUserTelEdit &&
			!enableUserFaxEdit &&
			!enableUserEmail1Edit &&
			!enableUserEmail2Edit &&
			!enableUserCareerMemoEdit;

		const editing = !this.equals(stored, edited);
		if (editing) {
			//
		}

		return (
			<>
				<Paper className={classes.paper}>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="loginId"
									label={i18n.t('ProfileForm_0003')}
									value={edited.loginId}
									onChange={this.handleChange}
									margin="normal"
									fullWidth={true}
									disabled={true}
								/>
							</Grid>
						</Grid>
						{enablePasswordEdit && (
							<Grid container={true} spacing={3}>
								<Grid item={true} xs={12} sm={6}>
									<InputLabel className={classes.cssLabel}>
										{i18n.t('ProfileForm_0004')}
									</InputLabel>
									<IconButton
										onClick={this.handleTogglePassword}
									>
										<EditIcon
											className={classes.iconEdit}
										/>
									</IconButton>
								</Grid>
							</Grid>
						)}
						{enablePasswordEdit && this.state.showPassword && (
							<Grid container={true} spacing={3}>
								<Grid item={true} xs={12} sm={6}>
									<TextField
										id="password"
										label={i18n.t('ProfileForm_0005')}
										value={edited.password}
										onChange={this.handleChange}
										type="password"
										required={true}
									/>
								</Grid>
								<Grid item={true} xs={12} sm={6}>
									<TextField
										id="rePassword"
										label={i18n.t('ProfileForm_0006')}
										value={edited.rePassword}
										onChange={this.handleChange}
										type="password"
										required={true}
									/>
								</Grid>
							</Grid>
						)}
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="familyNameJa"
									label={i18n.t('ProfileForm_0007')}
									value={edited.familyNameJa}
									onChange={this.handleChange}
									required={true}
									disabled={!enableUserNameEdit}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="firstNameJa"
									label={i18n.t('ProfileForm_0008')}
									value={edited.firstNameJa}
									onChange={this.handleChange}
									disabled={!enableUserNameEdit}
								/>
							</Grid>
						</Grid>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="familyNameKanaJa"
									label={i18n.t('ProfileForm_0009')}
									value={edited.familyNameKanaJa}
									onChange={this.handleChange}
									disabled={!enableUserNameEdit}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="firstNameKanaJa"
									label={i18n.t('ProfileForm_0010')}
									value={edited.firstNameKanaJa}
									onChange={this.handleChange}
									disabled={!enableUserNameEdit}
								/>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3} alignItems="center">
							<Grid item={true} xs={2} md={1}>
								{enableUserPhotoEdit && (
									<InputLabel className={classes.cssLabel}>
										{i18n.t('ProfileForm_0011')}
									</InputLabel>
								)}
								{!enableUserPhotoEdit && (
									<InputLabel>
										{i18n.t('ProfileForm_0012')}
									</InputLabel>
								)}
							</Grid>
							<Grid item={true} xs={4} md={2}>
								<img id="userImg" src={userImage} width={150} />
								<form
									method="POST"
									action={
										Config.tsqPath +
										'/tsq/ui/common/resources/rest/file/upload'
									}
									encType="multipart/form-data"
									ref={form => (this.uploadForm = form)}
								>
									<input
										id="uploadFile"
										name="uploadFile"
										onChange={this.handleImageChange}
										type="file"
										ref={input => (this.uploadFile = input)}
										style={{ display: 'none' }}
									/>
								</form>
							</Grid>
							{enableUserPhotoEdit && !isMobile() && (
								<Grid item={true} xs={2} md={2}>
									<IconButton
										onClick={this.handleOpenFileDialog}
									>
										<AddCircle
											className={classes.iconAdd}
										/>
									</IconButton>
									<IconButton
										onClick={this.handleRemoveUserImage}
										disabled={!enableImgDelButton}
									>
										<RemoveCircle
											className={
												enableImgDelButton
													? classes.iconRemove
													: classes.iconRemoveDisabled
											}
										/>
									</IconButton>
								</Grid>
							)}
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="workStartDate"
									label={i18n.t('ProfileForm_0013')}
									value={edited.workStartDate}
									onChange={this.handleChange}
									disabled={true}
								/>
							</Grid>
						</Grid>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="userOrgList"
									multiline={true}
									rows="5"
									label={i18n.t('ProfileForm_0014')}
									value={userOrgs.join('\r\n')}
									disabled={true}
								/>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} md={6}>
								<FormSelect
									label={i18n.t('ProfileForm_0015')}
									id="countryCode"
									input={<Input name="countryCode" />}
									autoWidth={true}
									onChange={this.handleChangeSelect}
									value={edited.countryCode}
									displayEmpty={false}
									disabled={!enableUserCountryEdit}
								>
									{this.getMenuList(this.props.countryMaster)}
								</FormSelect>
							</Grid>
							<Grid item={true} xs={12} md={6}>
								<FormSelect
									label={i18n.t('ProfileForm_0016')}
									id="timeZone"
									input={<Input name="timeZone" />}
									autoWidth={true}
									onChange={this.handleChangeSelect}
									value={edited.timeZone}
									displayEmpty={false}
									className={classes.cssUnderline}
									disabled={!enableUserTimezoneEdit}
								>
									{this.getMenuList(
										this.props.timezoneMaster
									)}
								</FormSelect>
							</Grid>
							<Grid item={true} xs={12} md={6}>
								<FormSelect
									label={i18n.t('ProfileForm_0017')}
									id="lang"
									input={<Input name="lang" />}
									autoWidth={true}
									onChange={this.handleChangeSelect}
									value={edited.lang}
									displayEmpty={false}
									disabled={!enableUserLangEdit}
								>
									{this.getMenuList(this.props.langMaster)}
								</FormSelect>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={6} md={4}>
								<TextField
									id="lederUserName"
									label={i18n.t('ProfileForm_0018')}
									value={edited.lederUserName}
									onChange={this.handleChange}
									disabled={true}
								/>
							</Grid>
							{enableUserLeaderEdit && (
								<Grid item={true} xs={4} md={4}>
									{!isMobile() && (
										<>
											<IconButton
												onClick={
													this
														.handleOpenSelectUserDialog
												}
											>
												<AddCircle
													className={classes.iconAdd}
												/>
											</IconButton>
											<IconButton
												onClick={
													this
														.handleDeleteSelectedUser
												}
												disabled={
													edited.lederUserName === ''
												}
											>
												<RemoveCircle
													className={
														edited.lederUserName !==
														''
															? classes.iconRemove
															: classes.iconRemoveDisabled
													}
												/>
											</IconButton>
										</>
									)}
								</Grid>
							)}
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<FormSelect
									label={i18n.t('ProfileForm_0019')}
									id="officeId"
									input={<Input name="officeId" />}
									autoWidth={true}
									onChange={this.handleChangeSelect}
									value={
										edited.officeId
											? edited.officeId
											: '...'
									}
									displayEmpty={true}
									disabled={true}
								>
									<MenuItem value="...">
										{i18n.t('ProfileForm_0020')}
									</MenuItem>
									{this.getMenuList(this.props.officeMaster)}
								</FormSelect>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<FormSelect
									label={i18n.t('ProfileForm_0021')}
									id="employeeCategoryId"
									input={<Input name="employeeCategoryId" />}
									autoWidth={true}
									onChange={this.handleChangeSelect}
									value={
										edited.employeeCategoryId
											? edited.employeeCategoryId
											: '...'
									}
									displayEmpty={true}
									disabled={true}
								>
									<MenuItem value="...">
										{i18n.t('ProfileForm_0022')}
									</MenuItem>
									{this.getMenuList(
										this.props.employeeCategoryMaster
									)}
								</FormSelect>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<FormSelect
									label={i18n.t('ProfileForm_0023')}
									id="occupationId"
									input={<Input name="occupationId" />}
									autoWidth={true}
									onChange={this.handleChangeSelect}
									value={
										edited.occupationId
											? edited.occupationId
											: '...'
									}
									displayEmpty={true}
									disabled={true}
								>
									<MenuItem value="...">
										{i18n.t('ProfileForm_0024')}
									</MenuItem>
									{this.getMenuList(
										this.props.occupationMaster
									)}
								</FormSelect>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<FormLabel component="legend">
									{i18n.t('ProfileForm_0025')}
								</FormLabel>
								<RadioGroup
									aria-label={i18n.t('ProfileForm_0026')}
									value={edited.seibetu}
									onChange={this.handleChange}
								>
									<FormControlLabel
										value="1"
										control={
											<Radio
												id="seibetu"
												disabled={true}
											/>
										}
										label={i18n.t('ProfileForm_0027')}
									/>
									<FormControlLabel
										value="2"
										control={
											<Radio
												id="seibetu"
												disabled={true}
											/>
										}
										label={i18n.t('ProfileForm_0028')}
									/>
									<FormControlLabel
										value="0"
										control={
											<Radio
												id="seibetu"
												disabled={true}
											/>
										}
										label={i18n.t('ProfileForm_0029')}
									/>
								</RadioGroup>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="birthday"
									label={i18n.t('ProfileForm_0030')}
									value={edited.birthday}
									onChange={this.handleChange}
									margin="normal"
									disabled={true}
									fullWidth={true}
								/>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="addressJa"
									label={i18n.t('ProfileForm_0031')}
									value={edited.addressJa}
									onChange={this.handleChange}
									disabled={!enableUserAddressEdit}
								/>
							</Grid>
						</Grid>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="homePhone"
									label={i18n.t('ProfileForm_0032')}
									value={edited.homePhone}
									onChange={this.handleChange}
									disabled={!enableUserTelEdit}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="faxNumber"
									label={i18n.t('ProfileForm_0033')}
									value={edited.faxNumber}
									onChange={this.handleChange}
									disabled={!enableUserFaxEdit}
								/>
							</Grid>
						</Grid>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="email1"
									label={i18n.t('ProfileForm_0034')}
									value={edited.email1}
									onChange={this.handleChange}
									disabled={!enableUserEmail1Edit}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="email2"
									label={i18n.t('ProfileForm_0035')}
									value={edited.email2}
									onChange={this.handleChange}
									disabled={!enableUserEmail2Edit}
								/>
							</Grid>
						</Grid>
					</div>
					<div className={classes.layout}>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="careerMemoJa"
									multiline={true}
									rows="5"
									label={i18n.t('ProfileForm_0036')}
									value={edited.careerMemoJa}
									onChange={this.handleChange}
									disabled={!enableUserCareerMemoEdit}
								/>
							</Grid>
						</Grid>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="noteJa"
									multiline={true}
									rows="5"
									label={i18n.t('ProfileForm_0037')}
									value={edited.noteJa}
									onChange={this.handleChange}
									disabled={true}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="orgList"
									multiline={true}
									rows="5"
									label={i18n.t('ProfileForm_0038')}
									value={manageOrgs.join('\r\n')}
									disabled={true}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6}>
								<TextField
									id="groupList"
									multiline={true}
									rows="5"
									label={i18n.t('ProfileForm_0039')}
									value={manageGroups.join('\r\n')}
									disabled={true}
								/>
							</Grid>
						</Grid>
						<Grid container={true} spacing={3}>
							<Grid item={true} xs={12}>
								<Button
									variant="contained"
									color="primary"
									disabled={allDisabled || !editing}
									onClick={this.handleRegister}
								>
									{i18n.t('ProfileForm_0040')}
								</Button>
							</Grid>
						</Grid>
					</div>
				</Paper>
				<SelectUser
					open={this.state.selectUserOpen}
					onClose={this.handleCloseSelectUserDialog}
					onSelect={this.handleSelectUser}
				/>
				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('ProfileForm_0041')}
					contents={this.state.messages}
					onClose={this.handleErrorMessageDialogClose}
					onClickOk={this.handleErrorMessageDialogClose}
				/>
				<MessageDialog
					open={this.props.saveCompleteFlg}
					showCancelButton={false}
					title={i18n.t('ProfileForm_0042')}
					contents={messages}
					onClose={completeDialogCallback}
					onClickOk={completeDialogCallback}
				/>
			</>
		);
	}

	/**
	 * エラーメッセージクローズ
	 */
	protected handleErrorMessageDialogClose = () => {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	};

	/**
	 * 完了メッセージクローズ
	 */
	protected handleMessageDialogClose = () => {
		this.props.setSaveProfileCompleteFlg(false);
	};

	/**
	 * 完了メッセージクローズ(ログアウト処理を含む)
	 */
	protected handleMessageDialogCloseWithLogout = () => {
		this.props.setSaveProfileCompleteFlg(false);
		this.props.logout(
			this.props.token,
			this.props.tsqWindow,
			this.props.userAttr
		);
	};

	/**
	 * パスワード入力フォームトグル処理
	 */
	protected handleTogglePassword = () => {
		const { showPassword } = this.state;
		this.setState({
			showPassword: !showPassword,
		});
		// 非表示にする際、パスワードをリセット
		if (showPassword) {
			const newObj: IProfile = {
				...this.props.editedProfile,
			};
			newObj.password = '';
			newObj.rePassword = '';
			this.props.setEditedProfile(newObj);
		}
	};

	/**
	 * ファイルダイアログ表示
	 */
	protected handleOpenFileDialog = () => {
		if (this.uploadFile) {
			this.uploadFile.click();
		}
	};

	/**
	 * プルダウンメニュー生成処理
	 */
	protected getMenuList(master: { [code: string]: string }): JSX.Element[] {
		const menuList: JSX.Element[] = [];
		for (const code in master) {
			if (master[code]) {
				menuList.push(<MenuItem value={code}>{master[code]}</MenuItem>);
			}
		}
		return menuList;
	}

	/**
	 * ユーザ選択ダイアログ表示
	 */
	protected handleOpenSelectUserDialog = () => {
		this.setState({
			selectUserOpen: true,
		});
	};

	/**
	 * ユーザ選択ダイアログ非表示
	 */
	protected handleCloseSelectUserDialog = () => {
		this.setState({
			selectUserOpen: false,
		});
	};

	/**
	 * 評価者選択コールバック
	 * @param selectUser 選択ユーザ情報
	 */
	protected handleSelectUser = (selectUser: ISelectUser) => {
		this.setState({
			selectUserOpen: false,
		});
		const { userId, userName, userFamilyName } = selectUser;
		let name: string = '';
		name += userFamilyName ? userFamilyName : '';
		name += ' ';
		name += userName ? userName : '';
		const newObj: IProfile = {
			...this.props.editedProfile,
			lederUserId: userId,
			lederUserName: name,
		};
		this.props.setEditedProfile(newObj);
	};

	/**
	 * 評価者破棄処理
	 */
	protected handleDeleteSelectedUser = () => {
		const newObj: IProfile = {
			...this.props.editedProfile,
			lederUserId: '',
			lederUserName: '',
		};
		this.props.setEditedProfile(newObj);
	};

	/**
	 * 入力値変更処理
	 */
	protected handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const target = event.target as HTMLInputElement;
		const newObj: IProfile = {
			...this.props.editedProfile,
		};
		newObj[target.id] = target.value;
		this.props.setEditedProfile(newObj);
	};

	/**
	 * 画像変更処理
	 */
	protected handleImageChange = (
		event: React.FormEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		if (!target.files || target.files.length === 0) {
			return;
		}

		const file = target.files[0];
		if (!/\.(gif|jpg|jpeg|bmp|png)$/i.test(file.name)) {
			const message: IMessage = {
				content: 'LMCM_E_00470',
			};
			this.setState({
				messages: [message],
				openErrorMessageDialog: true,
			});
			target.value = '';
			return;
		}

		const fileReader = new FileReader();
		fileReader.onload = (e: Event) => {
			if (typeof fileReader.result === 'string') {
				this.setState({
					enableImgDelButton: true,
					userImg: fileReader.result,
				});
			}
		};
		fileReader.readAsDataURL(file);
	};

	/**
	 * 画像破棄処理
	 */
	protected handleRemoveUserImage = () => {
		if (this.uploadFile) {
			this.uploadFile.value = '';
		}
		this.setState({
			enableImgDelButton: false,
			userImg: noImage,
		});
		// 画像削除フラグをON
		const newObj: IProfile = {
			...this.props.editedProfile,
		};
		newObj.deleteImage = true;
		this.props.setEditedProfile(newObj);
	};

	/**
	 * プルダウン変更処理
	 */
	protected handleChangeSelect = (
		event: React.ChangeEvent<HTMLSelectElement>
	) => {
		const target = event.target as HTMLSelectElement;
		const newObj: IProfile = {
			...this.props.editedProfile,
		};
		newObj[target.name] = target.value;
		this.props.setEditedProfile(newObj);
	};

	/**
	 * 登録処理
	 */
	protected handleRegister = () => {
		const { editedProfile } = this.props;
		const messages: IMessage[] = [];

		// 入力チェック
		// 必須チェック
		const { familyNameJa } = editedProfile;
		if (InputCheck.isBlank(familyNameJa)) {
			messages.push({
				content: 'CHK_E_0001',
				replacements: [i18n.t('ProfileForm_0043')],
			});
		}

		// パスワード
		const { password, rePassword } = editedProfile;
		if (password && !InputCheck.isBlank(password)) {
			// 書式チェック（半角英数・ハイフン・アンダーバー・記号「. @ ! # $ % & ' * + / = ? ^ ` { | }」を許可）
			if (password.match(/[^\d\w\-.@!#$%&'_`/=\*\+\?\^{|}]+/)) {
				messages.push({
					content: 'LMCM_E_00491',
					replacements: [
						i18n.t('ProfileForm_0044'),
						i18n.t('ProfileForm_0045'),
					],
				});
			} else if (password.length > 256) {
				// 文字数チェック
				messages.push({
					content: 'CHK_E_0004',
					replacements: [i18n.t('ProfileForm_0046'), '256'],
				});
			}
		}
		if (
			(password && !InputCheck.isBlank(password)) ||
			(rePassword && !InputCheck.isBlank(rePassword))
		) {
			// 同一チェック
			if (password !== rePassword) {
				messages.push({
					content: 'LMCM_E_00492',
					replacements: [
						i18n.t('ProfileForm_0047'),
						i18n.t('ProfileForm_0048'),
					],
				});
			}
		}

		// 姓
		if (
			familyNameJa &&
			!InputCheck.isBlank(familyNameJa) &&
			familyNameJa.length > 100
		) {
			// 文字数チェック
			messages.push({
				content: 'CHK_E_0004',
				replacements: [i18n.t('ProfileForm_0049'), '100'],
			});
		}

		// 名
		const { firstNameJa } = editedProfile;
		if (
			firstNameJa &&
			!InputCheck.isBlank(firstNameJa) &&
			firstNameJa.length > 100
		) {
			// 文字数チェック
			messages.push({
				content: 'CHK_E_0004',
				replacements: [i18n.t('ProfileForm_0050'), '100'],
			});
		}

		// 姓カナ
		const { familyNameKanaJa } = editedProfile;
		if (
			familyNameKanaJa &&
			!InputCheck.isBlank(familyNameKanaJa) &&
			familyNameKanaJa.length > 100
		) {
			// 文字数チェック
			messages.push({
				content: 'CHK_E_0004',
				replacements: [i18n.t('ProfileForm_0051'), '100'],
			});
		}

		// 名カナ
		const { firstNameKanaJa } = editedProfile;
		if (
			firstNameKanaJa &&
			!InputCheck.isBlank(firstNameKanaJa) &&
			firstNameKanaJa.length > 100
		) {
			// 文字数チェック
			messages.push({
				content: 'CHK_E_0004',
				replacements: [i18n.t('ProfileForm_0052'), '100'],
			});
		}

		// 住所
		const { addressJa } = editedProfile;
		if (
			addressJa &&
			!InputCheck.isBlank(addressJa) &&
			addressJa.length > 100
		) {
			// 文字数チェック
			messages.push({
				content: 'CHK_E_0004',
				replacements: [i18n.t('ProfileForm_0053'), '100'],
			});
		}

		// 電話番号
		const { homePhone } = editedProfile;
		if (homePhone && !InputCheck.isBlank(homePhone) && homePhone !== '') {
			if (!InputCheck.validationTelNoChar(homePhone)) {
				// 書式チェック（電話・FAX番号の文字種（半角数字＋ハイフン））
				messages.push({
					content: 'CHK_E_0028',
					replacements: [i18n.t('ProfileForm_0054')],
				});
			} else if (homePhone.length > 20) {
				// 文字数チェック
				messages.push({
					content: 'CHK_E_0004',
					replacements: [i18n.t('ProfileForm_0055'), '20'],
				});
			}
		}

		// Fax番号
		const { faxNumber } = editedProfile;
		if (faxNumber && !InputCheck.isBlank(faxNumber) && faxNumber !== '') {
			if (!InputCheck.validationTelNoChar(faxNumber)) {
				// 書式チェック（電話・FAX番号の文字種（半角数字＋ハイフン））
				messages.push({
					content: 'CHK_E_0028',
					replacements: [i18n.t('ProfileForm_0056')],
				});
			} else if (faxNumber.length > 20) {
				// 文字数チェック
				messages.push({
					content: 'CHK_E_0004',
					replacements: [i18n.t('ProfileForm_0057'), '20'],
				});
			}
		}

		// メインメール
		const { email1 } = editedProfile;
		if (email1 && !InputCheck.isBlank(email1) && email1 !== '') {
			if (!InputCheck.validationEMail(email1)) {
				// フォーマットチェック（メールアドレス用）
				messages.push({
					content: 'CHK_E_0031',
					replacements: [i18n.t('ProfileForm_0058')],
				});
			} else if (email1.length > 256) {
				// 文字数チェック
				messages.push({
					content: 'CHK_E_0004',
					replacements: [i18n.t('ProfileForm_0059'), '256'],
				});
			}
		}

		// サブメール
		const { email2 } = editedProfile;
		if (email2 && !InputCheck.isBlank(email2) && email2 !== '') {
			if (!InputCheck.validationEMail(email2)) {
				// フォーマットチェック（メールアドレス用）
				messages.push({
					content: 'CHK_E_0031',
					replacements: [i18n.t('ProfileForm_0060')],
				});
			} else if (email2.length > 256) {
				// 文字数チェック
				messages.push({
					content: 'CHK_E_0004',
					replacements: [i18n.t('ProfileForm_0061'), '256'],
				});
			}
		}

		// 経歴
		const { careerMemoJa } = editedProfile;
		if (
			careerMemoJa &&
			!InputCheck.isBlank(careerMemoJa) &&
			careerMemoJa.length > 1000
		) {
			// 文字数チェック
			messages.push({
				content: 'CHK_E_0004',
				replacements: [i18n.t('ProfileForm_0062'), '1000'],
			});
		}

		// エラーメッセージ表示
		if (messages.length > 0) {
			this.setState({
				messages,
				openErrorMessageDialog: true,
			});
			return;
		}

		// 登録処理
		const newObj: IProfile = {
			...editedProfile,
		};
		// 言語分コピー
		// 住所
		newObj.addressEn = newObj.addressJa;
		newObj.addressZh = newObj.addressJa;
		// 姓
		newObj.familyNameEn = newObj.familyNameJa;
		newObj.familyNameZh = newObj.familyNameJa;
		// 名
		newObj.firstNameEn = newObj.firstNameJa;
		newObj.firstNameZh = newObj.firstNameJa;
		// 姓カナ
		newObj.familyNameKanaEn = newObj.familyNameKanaJa;
		newObj.familyNameKanaZh = newObj.familyNameKanaJa;
		// 名カナ
		newObj.firstNameKanaEn = newObj.firstNameKanaJa;
		newObj.firstNameKanaZh = newObj.firstNameKanaJa;
		// 経歴等
		newObj.careerMemoEn = newObj.careerMemoJa;
		newObj.careerMemoZh = newObj.careerMemoJa;
		// 備考
		newObj.noteEn = newObj.noteJa;
		newObj.noteZh = newObj.noteJa;

		// 画像ファイルの有無で処理を分ける
		if (this.uploadFile && this.uploadFile.value !== '') {
			if (!this.uploadForm) {
				return;
			}
			const form = new FormData(this.uploadForm);
			const modelData = {
				per_user_UserDetailBlockModel: {
					...newObj,
				},
			};
			form.append('__modelData', JSON.stringify(modelData));
			const request = new XMLHttpRequest();
			request.open(
				'POST',
				Config.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
				true
			);
			request.setRequestHeader('Accept', 'application/json');
			request.onreadystatechange = () => {
				this.props.setSaveProfileCompleteFlg(true);
			};
			request.send(form);
		} else {
			this.props.saveUserProfile(this.props.token, {
				storedProfile: this.props.storedProfile,
				userProfile: newObj,
			});
		}
	};

	/**
	 * ユーザ情報比較
	 * @param l 比較対象1
	 * @param r 比較対象2
	 */
	protected equals(l: any, r: any) {
		if (Array.isArray(l)) {
			if (!Array.isArray(r)) {
				return false;
			}
			// 配列同士
			if (l.length !== r.length) {
				return false;
			}
			for (let i = 0; i < l.length; i++) {
				if (!this.equals(l[i], r[i])) {
					return false;
				}
			}
			return true;
		}

		if (l === null && r === null) {
			return true;
		}

		const type = typeof l;
		if (type !== typeof r) {
			return false;
		}
		if (type === 'undefined') {
			return true;
		}
		switch (type) {
			case 'boolean':
			case 'number':
			case 'string':
			case 'symbol':
			case 'function':
				// プリミティブ型
				return l === r;
		}
		if (type !== 'object') {
			return false;
		}
		// object
		const keysl = Object.keys(l);
		const keysr = Object.keys(r);
		if (keysl.length !== keysr.length) {
			return false;
		}
		for (const key of keysl) {
			if (!this.equals(l[key], r[key])) {
				return false;
			}
		}
		return true;
	}
}

const mapStateToProps = (state: IRootState) => ({
	countryMaster: state.profile.countryMaster,
	editedProfile: state.profile.editedProfile,
	employeeCategoryMaster: state.profile.employeeCategoryMaster,
	langMaster: state.profile.langMaster,
	needLogoutFlg: state.profile.needLogoutFlg,
	occupationMaster: state.profile.occupationMaster,
	officeMaster: state.profile.officeMaster,
	saveCompleteFlg: state.profile.saveCompleteFlg,
	setStoredProfileAt: state.profile.setStoredProfileAt,
	storedProfile: state.profile.storedProfile,
	timezoneMaster: state.profile.timezoneMaster,
	token: state.session.token,
	tsqWindow: state.mainMenu.tsqWindow,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchProfile: (token: string) => {
		const s = ScenarioFactory.createFetchProfile(dispatch, token);
		s.run({});
	},
	logout: (token: string, tsqWindow: Window | null, userAttr: IUserAttr) => {
		const s = NavbarScenarioFactory.createLogout(
			dispatch,
			token,
			userAttr.loginType
		);
		s.run({ tsqWindow });
	},
	saveUserProfile: (token: string, arg: ISaveUserProfileParam) => {
		const s = ScenarioFactory.createSaveUserProfile(dispatch, token);
		s.run(arg);
	},
	setEditedProfile: (value: IProfile) =>
		dispatch(setEditedProfile({ value })),
	setSaveProfileCompleteFlg: (flg: boolean) =>
		dispatch(
			setSaveProfileCompleteFlg({
				needLogoutFlg: false,
				saveCompleteFlg: flg,
			})
		),
	setStoredProfile: (value: IProfile) =>
		dispatch(setStoredProfile({ value })),
});

// tslint:disable-next-line: no-empty-interface
export interface IProfileFormProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IProfileFormProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ProfileForm);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/ProfileForm.tsx